import React from "react";
import PropTypes from "prop-types";
import screenfull from "screenfull";
import favorites from "../../helpers/favorites";
import regeneratorRuntime from "regenerator-runtime";
import zoomHandler from "../../helpers/gamescreen/zoomHandler";
import OutsideClickHandler from "react-outside-click-handler";

class GameActions extends React.Component {
	constructor(props) {
		super(props);

		const host = window.location.host;

		let alt = "";
		let height = "16";
		if (host.includes("juegosjuegos")) {
			alt = "juegosjuegos";
		} else if (host.includes("jogosjogos")) {
			alt = "jogosjogos";
		} else {
			alt = "pomu";
			height = "22";
		}
		let iconName = `${window.cdns[0]}public/images/logo_${alt}_embed`;
		if (window.isRetinadisplay) {
			iconName += "@2x";
		}
		iconName += ".png";

		this.state = {
			showLoadingIcon: true,
			fullscreenIcon: "fa-arrows-alt",
			isFavorited: favorites.isFavorited(this.props.id),
			currentZoom: 1,
			outsideTimer: 0,
			alt,
			iconName,
			height
		};

		this.selectText = this.selectText.bind(this);
		this.changeIcon = this.changeIcon.bind(this);
		this.addFavorite = this.addFavorite.bind(this);
		this.showIframe = this.showIframe.bind(this);
		this.hideIframe = this.hideIframe.bind(this);

		this.addZoom = this.addZoom.bind(this);
		this.removeZoom = this.removeZoom.bind(this);
		this.updateZoom = this.updateZoom.bind(this);
		this.zoomHandler = new zoomHandler(this.props.size_x, this.updateZoom);
	}

	changeIcon() {
		this.setState({
			fullscreenIcon: screenfull.isFullscreen ? "fa-compress" : "fa-arrows-alt"
		});
	}
	componentDidMount() {
		if (screenfull.enabled) {
			screenfull.on("change", this.changeIcon);
		}
		this.zoomHandler.initSlider();
	}
	componentWillUnmount() {
		if (screenfull.enabled) {
			screenfull.off("change", this.changeIcon);
		}
	}
	selectText(event) {
		event.target.select();
	}
	addFavorite() {
		favorites.toggler(this.props.id);
		const isFavorited = favorites.isFavorited(this.props.id);
		this.setState({
			isFavorited
		});
	}
	showIframe() {
		this.setState({
			showIframe: !this.state.showIframe
		});
	}
	hideIframe(e) {
		this.setState({
			showIframe: false
		});
	}

	addZoom() {
		const currentZoom = this.zoomHandler.setZoom(
			this.state.currentZoom + this.zoomHandler.getStepsWidth()
		);
		this.setState({
			currentZoom
		});
	}
	removeZoom() {
		const currentZoom = this.zoomHandler.setZoom(
			this.state.currentZoom - this.zoomHandler.getStepsWidth()
		);
		this.setState({
			currentZoom
		});
	}
	updateZoom(currentZoom) {
		this.setState({
			currentZoom
		});
	}

	render() {
		const gameScreen = document.getElementById("gameContainer");

		return (
			<React.Fragment>
				<div className="GameActions">
					<img
						src={this.state.iconName}
						alt={this.state.alt}
						height={this.state.height}
					/>
					{this.props.zoom &&
					!document
						.getElementsByTagName("html")[0]
						.classList.contains("firefox") ? (
						<div
							className="GameScreen-GameBox-zoom"
							style={screenfull.isFullscreen ? { display: "none" } : null}
						>
							<i onClick={this.removeZoom} className="fa fa-search-minus" />
							<div className="zoomHandler" />
							<i onClick={this.addZoom} className="fa fa-search-plus" />
						</div>
					) : null}
					<div className="toRight">
						<OutsideClickHandler
							onOutsideClick={this.hideIframe}
							display="inline-block"
						>
							<div className="getIframe">
								<button className="tooltip" onClick={this.showIframe}>
									<i className="fa fa-code" />
									<span className="tooltiptext tooltip-top">
										{this.props.translate.insert_iframe_description}
									</span>
								</button>

								<div
									className={`getIframe-contenido ${
										this.state.showIframe ? "show" : ""
									}`}
								>
									<div className="separador">
										<i className="fa fa-caret-up" aria-hidden="true" />
									</div>
									<input
										value={this.props.embed_url}
										readOnly
										onFocus={this.selectText}
									/>
									{this.props.translate.embed_code}
									{/* prettier-ignore */}
									<textarea
                                    onClick={this.selectText}
									defaultValue={`<iframe src="${this.props.embed_url}" width="${this.props.size_x}" height="${this.props.size_y}" marginwidth="0" marginheight="0" hspace="0" vspace="0" frameborder="0" scrolling="no" webkitallowfullscreen="true" mozallowfullscreen="true" msallowfullscreen="true" allowfullscreen="true" />`}
								/>
								</div>
							</div>
						</OutsideClickHandler>

						{this.props.zoom ? (
							<button
								className="tooltip"
								onClick={() => screenfull.toggle(gameScreen)}
							>
								<i className={`fa ${this.state.fullscreenIcon}`} />
								<span className="tooltiptext tooltip-top">
									{this.props.translate.Fullscreen}
								</span>
							</button>
						) : null}
					</div>
				</div>
			</React.Fragment>
		);
	}
}
GameActions.propTypes = {
	translate: PropTypes.object, // eslint-disable-line react/forbid-prop-types
	embed_url: PropTypes.string.isRequired,
	name: PropTypes.string,
	zoom: PropTypes.bool.isRequired,
	size_y: PropTypes.number.isRequired,
	size_x: PropTypes.number.isRequired,
	id: PropTypes.number.isRequired
};
GameActions.defaultProps = {
	translate: {
		insert_iframe_description: "Pon este juego en tu web",
		como_jugar: "Cómo Jugar",
		add_favorite: "Agregar a Favorito",
		QUITAR_FAVORITO: "Quitar de favoritos",
		Fullscreen: "Fullscreen",
		embed_code: "Embed Code"
	}
};
export default GameActions;
